module.exports = __webpack_public_path__ + "img/standard.8ddd4438.svg";